import axios from 'axios';
import { getBrowserCookie } from 'Utils/browserCookieUtils';

class BaseService {
  constructor(baseURL, type) {
    this.baseURL = baseURL;
    this.jwtType = type;
    this.auth = type === 'bo' ? getBrowserCookie('t_token_backoffice') : getBrowserCookie('jwt');
  }

  failureInterceptor(error) {
    return Promise.reject(error);
  }

  createAxiosInstance() {
    const axiosInstance = {
      headers: { Authorization: `Bearer ${this.auth}` },
      validateStatus: status => status >= 200 && status <= 500 && status !== 401 && status !== 400,
      baseURL: this.baseURL
    };

    if (this.jwtType !== 'bo') {
      delete axiosInstance.headers;
      axiosInstance.withCredentials = true;
    }

    const instance = axios.create(axiosInstance);

    instance.interceptors.response.use(response => response, this.failureInterceptor);

    return instance;
  }

  get(url = '', ...params) {
    const axiosInstance = this.createAxiosInstance();
    return axiosInstance.get(this.baseURL + url, ...params);
  }

  post(url = '', ...params) {
    const axiosInstance = this.createAxiosInstance();
    return axiosInstance.post(this.baseURL + url, ...params);
  }

  put(url = '', ...params) {
    const axiosInstance = this.createAxiosInstance();
    return axiosInstance.put(this.baseURL + url, ...params);
  }

  delete(url = '', ...params) {
    const axiosInstance = this.createAxiosInstance();
    return axiosInstance.delete(this.baseURL + url, ...params);
  }

  patch(url = '', ...params) {
    const axiosInstance = this.createAxiosInstance();
    return axiosInstance.patch(this.baseURL + url, ...params);
  }
}

export default BaseService;
